import { ChakraProvider, Tag } from "@chakra-ui/react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { Security } from "@okta/okta-react";
import * as React from "react";
import { useHistory } from "react-router";
import UserContextProvider from "./components/UserContextProvider";
import { oktaInternalAuthConfig } from "./lib/auth-config";
import AppRoutes from "./routes/AppRoutes";
import theme from "./theme/theme-config";

const oktaAuth = new OktaAuth(oktaInternalAuthConfig);

const isDevUrl =
  window.location.origin !== process.env.REACT_APP_ENVIRONMENT_PROD_URL;

export const App = () => {
  const history = useHistory();

  const customAuthHandler = () => {
    history.push("/login");
  };

  const restoreOriginalUri = async (
    _oktaAuth: OktaAuth,
    originalUri: string
  ) => {
    if (originalUri !== null) {
      history.replace(toRelativeUrl(originalUri, window.location.origin));
    } else {
      history.replace(toRelativeUrl("/", window.location.origin));
    }
  };

  return (
    <ChakraProvider theme={theme}>
      <Security
        oktaAuth={oktaAuth}
        onAuthRequired={customAuthHandler}
        restoreOriginalUri={restoreOriginalUri}
      >
        <UserContextProvider>
          <AppRoutes />
        </UserContextProvider>
      </Security>

      {isDevUrl && (
        <Tag
          colorScheme="green"
          position="fixed"
          top={2}
          right={2}
          paddingX={2}
          zIndex="overlay"
        >
          {process.env.REACT_APP_ENVIRONMENT}
        </Tag>
      )}
    </ChakraProvider>
  );
};
